import { call, put, takeEvery } from 'redux-saga/effects';
import { golfApi } from 'config/axios';

import {
    FETCH_GOLF_COURSE_LAYOUTS,
    FETCH_GOLF_COURSE_LAYOUTS_SUCCESS,
    FETCH_GOLF_COURSE_LAYOUTS_FAIL
} from '../actions/golfCourseActions.js';

export function* fetchGolfCourseLayoutsSaga(action) {
    try {
        const url = `/gcs-golfcommunity/api/v2/course-layout/${action.courseGlobalId}`;

        const response = yield call(golfApi.get, url);

        yield put({
            type: FETCH_GOLF_COURSE_LAYOUTS_SUCCESS,
            layouts: response.data,
            courseGlobalId: action.courseGlobalId
        });
    } catch (e) {
        yield put({
            type: FETCH_GOLF_COURSE_LAYOUTS_FAIL,
            layouts: [],
            courseGlobalId: action.courseGlobalId
        });
    }
}

export const golfCourseLayouts = [takeEvery(FETCH_GOLF_COURSE_LAYOUTS, fetchGolfCourseLayoutsSaga)];
